import type { PopperProps } from '@mui/material';
import MuiPopper from '@mui/material/Popper';
import { forwardRef } from 'react';

const Popper = forwardRef<HTMLDivElement, PopperProps>((props, ref) => {
  return <MuiPopper ref={ref} {...props} />;
});
Popper.displayName = 'Popper';
export default Popper;
